export default __webpack_public_path__ + "static/Transcript_Form-2eee0a5be45e73e9112bf7025e66e46a.pdf";